import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api/api.service';
import { FilterDepartmentsI } from './interfaces/filter-departments.interface';
import { DepartmentI } from './interfaces/department.interface';
import { CreateDepartmentRequestBodyI } from './dtos/create-department-request-body.interface';
import { RemoveDepartmentRequestQuery } from './dtos/remove-department-request-query.interface';
import { UpdateDepartmentRequestBodyI } from './dtos/update-department-request-body.interface';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsApisService {
  constructor(private readonly apiService: ApiService) {}
  findAll(filterDepartments: FilterDepartmentsI) {
    return this.apiService.get<DepartmentI[]>('departments', filterDepartments);
  }
  findAllForFaculty(facultyID: string, filterDepartments: FilterDepartmentsI) {
    return this.apiService.get<DepartmentI[]>(
      `departments/faculties/${facultyID}`,
      filterDepartments
    );
  }
  create(
    createDepartmentRequestBodyI: CreateDepartmentRequestBodyI,
    facultyID: string
  ) {
    return this.apiService.post<DepartmentI>(
      `departments/${facultyID}`,
      createDepartmentRequestBodyI
    );
  }
  findOne(departmentID: string) {
    return this.apiService.get<DepartmentI>(`departments/${departmentID}`);
  }
  count() {
    return this.apiService.get<number>('departments/count');
  }
  update(
    departmentID: string,
    updateDepartmentRequestBodyI: UpdateDepartmentRequestBodyI
  ) {
    return this.apiService.patch<DepartmentI>(
      `departments/${departmentID}`,
      updateDepartmentRequestBodyI
    );
  }
  removeDepartment(
    departmentID: string,
    removeDepartmentRequestQuery: RemoveDepartmentRequestQuery
  ) {
    return this.apiService.delete<DepartmentI>(
      `departments/${departmentID}`,
      removeDepartmentRequestQuery
    );
  }
}
